module.exports = __webpack_public_path__ + "img/vol06_character_name3.011ea46d.png";